import { formatCurrency, getCurrencySymbol, getLocaleNumberSymbol, NumberSymbol } from '@angular/common';
import { DEFAULT_CURRENCY_CODE, Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'clearMoney'})
export class clearMoney implements PipeTransform {

  transform(value: string): string {

    return value? value.replace(/,|[.]|/g, "") : value;

  }

}


@Pipe({name: 'numberFloat'})
export class numberFloat implements PipeTransform {

  transform(value: any): any {

    let new_value = value.toString()
    new_value = new_value.slice(0, -2)+'.'+new_value.slice(-2)
    
    
    return value? new_value : value;

  }

}

@Pipe({name: 'formatMoney'})
export class formatMoney implements PipeTransform {

  transform(value: any): any {

    let new_value = value.toString()
    new_value = new_value.slice(0, -2)+'.'+new_value.slice(-2)
    new_value = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL'}).format(new_value).replace('R$', '')
    new_value = new_value.slice(0, -3)+'<span class="cents">'+new_value.slice(-3)+'</span>'
    
    return value? new_value.trim() : value;

  }

}

@Pipe({name: 'formatMoneyText'})
export class formatMoneyText implements PipeTransform {

  transform(value: any): any {


    let new_value = value.toString().replace(/,|[.]|/g, "")
    new_value = new_value.slice(0, -2)+'.'+new_value.slice(-2)
    new_value = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL'}).format(new_value).replace('R$', '')
    new_value = 'R$ '+new_value
    
    return value? new_value.trim() : value;

  }

}


@Pipe({name: 'stripCode'})
export class stripCode implements PipeTransform {

  transform(value: any): any {

    value = value.split('-')
    return value? value[1].trim() : value;

  }

}

@Pipe({name: 'getCode'})
export class getCode implements PipeTransform {

  transform(value: any): any {

    value = value.split('-')
    return value? value[1].trim() : value;

  }

}



@Pipe({name: 'currencyMask'})

export class currencyMask implements PipeTransform {

  transform(value: any, ...args: any[]): any {


    let s
  
     const onlyDigits = value
     
      .split("")
      .filter((s:any) => /\d/.test(s))
      .join("")
      .padStart(3, "0")
      const digitsFloat = onlyDigits.slice(0, -2) + "." + onlyDigits.slice(-2)
  
      return "<span class='symbol'>"+this.maskCurrency(digitsFloat).slice(0,2)+"</span>"+this.maskCurrency(digitsFloat).slice(3, -3)+"<span class='cents'>"+this.maskCurrency(digitsFloat).slice(-3)+"</span>"
  
  }

  maskCurrency(valor:any, locale = 'pt-BR', currency = 'BRL') {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency
      }).format(valor)
    }
}


